import * as React from 'react';
import { useState } from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import Footer from 'shared/components/Footer';
import Benefits from './components/Benefits';
import { Header } from 'shared/components/Header';
import Awards from './components/Awards';
import Contacts from './components/Contacts';
import Section from './components/Section';
import News from './components/News';
import Books from './components/Books';
import Partners from './components/Partners';
import Previews from './components/Previews';
import LoginButton from 'components/LoginButton';
import InViewport from 'components/InViewPort';
import Results from './components/Results';

import './index.scss';

const b = b_.with('main-page');

export const MainPage: React.FC = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className={b()} data-testid={'main-page'}>
      <div className={b('wrapper')}>
        <Header />
        <div className={b('title')} data-testid="smart-investment">
          {t('Smart-Investments')}
        </div>
        <div className={b('benefits')} data-testid="benefits">
          <Benefits />
        </div>
        <LoginButton />
        <InViewport onChangeVisible={(isVisible) => setIsVisible(isVisible)}>
          <LoginButton fixedBottom isVisible={isVisible} />
        </InViewport>
        <Previews />
        <div>
          <Section title={t('Investments results')}>
            <Results />
          </Section>
          <Section>
            <Partners />
          </Section>
          <Section title={t('Our Awards')}>
            <Awards />
          </Section>
          {language === 'ru' && (
            <Section>
              <Books />
            </Section>
          )}
          <Section title={t('Our media interviews about investments')}>
            <News />
          </Section>
          <Section>
            <Contacts />
          </Section>
        </div>
      </div>
      <Footer isBig />
    </div>
  );
};
